export const supportedCoutries = [
  { country: 'United States', currency: 'USD', countryCode: 'US' },
  { country: 'Pakistan', currency: 'PKR', countryCode: 'PK' },
  { country: 'Argentina', currency: 'ARS', countryCode: 'AR' },
  // mexico
  { country: 'Mexico', currency: 'MXN', countryCode: 'MX' },
  // chile
  { country: 'Chile', currency: 'CLP', countryCode: 'CL' },
  // thailand
  { country: 'Thailand', currency: 'THB', countryCode: 'TH' },
  // malaysia
  { country: 'Malaysia', currency: 'MYR', countryCode: 'MY' },
  // philippines
  { country: 'Philippines', currency: 'PHP', countryCode: 'PH' },
  // nicaragua
  { country: 'Nicaragua', currency: 'NIO', countryCode: 'NI' },
  // costa rica
  { country: 'Costa Rica', currency: 'CRC', countryCode: 'CR' },
  // poland
  { country: 'Poland', currency: 'PLN', countryCode: 'PL' },
  // hong kong
  { country: 'Hong Kong', currency: 'HKD', countryCode: 'HK' },
  // india
  { country: 'India', currency: 'INR', countryCode: 'IN' },
  // ireland
  { country: 'Ireland', currency: 'EUR', countryCode: 'IE' },
  // singapore
  { country: 'Singapore', currency: 'SGD', countryCode: 'SG' },
  // taiwan
  { country: 'Taiwan', currency: 'TWD', countryCode: 'TW' },
  // united kingdom
  { country: 'United Kingdom', currency: 'GBP', countryCode: 'GB' }
]

export const payoutPlatforms = [
  { name: 'Stripe', value: 'STRIPE' },
  { name: 'Thera', value: 'THERA' },
  { name: 'Payoneer', value: 'PAYONEER' },
  { name: 'Wise', value: 'WISE' },
  { name: 'Other', value: 'OTHER' }
]

export const currencySymbols: { [key: string]: string } = {
  USD: '$',
  PKR: 'Rs',
  NIO: 'C$',
  CRC: '₡',
  PLN: 'zł',
  HKD: 'HK$',
  INR: '₹',
  EUR: '€',
  SGD: 'S$',
  TWD: 'NT$',
  GBP: '£'
}
